import { Stack } from '@fashionnovateam/nova-ui-toolkit';
import { NavigationBarProps } from './Props';
import { NavigationBarHeader } from './NavigationBarHeader';
import { NavigationBarFooter } from './NavigationBarFooter';
import { NavigationLinks } from './NavigationLinks';
import { useNavigation } from '../../Lib/Hooks/navigation';

export function NavigationBar(props: NavigationBarProps) {
  const {
    currentUser,
    user,
    applicationApproved,
    openUserManual,
    onClose,
    logout,
  } = props;

  const { isCollapsed } = useNavigation();

  return (
    <Stack
      direction="col"
      className={`h-full ${isCollapsed ? 'w-[60px] min-w-[60px]' : 'w-56 min-w-56'} bg-neutral-100 border-r nu-border-neutral-200 transition-all duration-300`}
    >
      <NavigationBarHeader
        user={user || currentUser}
        logout={logout}
        onClose={onClose}
      />
      {currentUser && (
        <>
          <NavigationLinks
            currentUser={currentUser}
            user={user}
            closeMobilePopup={onClose}
            applicationApproved={applicationApproved}
          />
          <NavigationBarFooter
            openUserManual={openUserManual}
            user={user || currentUser}
          />
        </>
      )}
    </Stack>
  );
}
